// ***** Single Job CRUD Action Types *****

// Create Single Job
export const CREATE_SINGLE_JOB = "CREATE_SINGLE_JOB";
export const CREATE_SINGLE_JOB_SUCCESS = "CREATE_SINGLE_JOB_SUCCESS";
export const CREATE_SINGLE_JOB_FAILURE = "CREATE_SINGLE_JOB_FAILURE";

// Read Single Job
export const READ_SINGLE_JOB = "READ_SINGLE_JOB";
export const READ_SINGLE_JOB_SUCCESS = "READ_SINGLE_JOB_SUCCESS";
export const READ_SINGLE_JOB_FAILURE = "READ_SINGLE_JOB_FAILURE";

// Update Single Job

export const UPDATE_SINGLE_JOB = "UPDATE_SINGLE_JOB";
export const UPDATE_SINGLE_JOB_SUCCESS = "UPDATE_SINGLE_JOB_SUCCESS";
export const UPDATE_SINGLE_JOB_FAILURE = "UPDATE_SINGLE_JOB_FAILURE";

// Delete Single Job
export const DELETE_SINGLE_JOB = "DELETE_SINGLE_JOB";
export const DELETE_SINGLE_JOB_SUCCESS = "DELETE_SINGLE_JOB_SUCCESS";
export const DELETE_SINGLE_JOB_FAILURE = "DELETE_SINGLE_JOB_FAILURE";

// ***** Single Job Notes Action Types *****

// Read Single Job all notes List
export const READ_SINGLE_JOB_NOTES_LIST = "READ_SINGLE_JOB_NOTES_LIST";
export const READ_SINGLE_JOB_NOTES_LIST_SUCCESS =
  "READ_SINGLE_JOB_NOTES_LIST_SUCCESS";
export const READ_SINGLE_JOB_NOTES_LIST_FAILURE =
  "READ_SINGLE_JOB_NOTES_LIST_FAILURE";

// Read Single Job single note
export const READ_SINGLE_JOB_NOTE = "READ_SINGLE_JOB_NOTE";
export const READ_SINGLE_JOB_NOTE_SUCCESS = "READ_SINGLE_JOB_NOTE_SUCCESS";
export const READ_SINGLE_JOB_NOTE_FAILURE = "READ_SINGLE_JOB_NOTE_FAILURE";

// Create Single Job Note
export const CREATE_SINGLE_JOB_NOTE = "CREATE_SINGLE_JOB_NOTE";
export const CREATE_SINGLE_JOB_NOTE_SUCCESS = "CREATE_SINGLE_JOB_NOTE_SUCCESS";
export const CREATE_SINGLE_JOB_NOTE_FAILURE = "CREATE_SINGLE_JOB_NOTE_FAILURE";

//*******************************************
// ***** Job Time Entry Action Types *****

// Get Job Time Entry List
export const GET_JOB_TIME_ENTRY_LIST = "GET_JOB_TIME_ENTRY_LIST";
export const GET_JOB_TIME_ENTRY_LIST_SUCCESS =
  "GET_JOB_TIME_ENTRY_LIST_SUCCESS";
export const GET_JOB_TIME_ENTRY_LIST_FAILURE =
  "GET_JOB_TIME_ENTRY_LIST_FAILURE";

// Create Job Time Entry
export const CREATE_JOB_TIME_ENTRY = "CREATE_JOB_TIME_ENTRY";
export const CREATE_JOB_TIME_ENTRY_SUCCESS = "CREATE_JOB_TIME_ENTRY_SUCCESS";
export const CREATE_JOB_TIME_ENTRY_FAILURE = "CREATE_JOB_TIME_ENTRY_FAILURE";

// Get Job attachment List for Single Job
export const GET_SINGLE_JOB_ATTACHMENT_LIST = "GET_SINGLE_JOB_ATTACHMENT_LIST";
export const GET_SINGLE_JOB_ATTACHMENT_LIST_SUCCESS =
  "GET_SINGLE_JOB_ATTACHMENT_LIST_SUCCESS";
export const GET_SINGLE_JOB_ATTACHMENT_LIST_FAILURE =
  "GET_SINGLE_JOB_ATTACHMENT_LIST_FAILURE";

// Get Single Job Recent Activity List
export const GET_SINGLE_JOB_RECENT_ACTIVITY_LIST =
  "GET_SINGLE_JOB_RECENT_ACTIVITY_LIST";
export const GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_SUCCESS =
  "GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_SUCCESS";
export const GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_FAILURE =
  "GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_FAILURE";

// Get Single Job Attachment URL
export const GET_SINGLE_JOB_ATTACHMENT_URL = "GET_SINGLE_JOB_ATTACHMENT_URL";
export const GET_SINGLE_JOB_ATTACHMENT_URL_SUCCESS =
  "GET_SINGLE_JOB_ATTACHMENT_URL_SUCCESS";
export const GET_SINGLE_JOB_ATTACHMENT_URL_FAILURE =
  "GET_SINGLE_JOB_ATTACHMENT_URL_FAILURE";

// Get Single Job Details For Timer
export const GET_SINGLE_JOB_DETAILS_FOR_TIMER =
  "GET_SINGLE_JOB_DETAILS_FOR_TIMER";
export const GET_SINGLE_JOB_DETAILS_FOR_TIMER_SUCCESS =
  "GET_SINGLE_JOB_DETAILS_FOR_TIMER_SUCCESS";
export const GET_SINGLE_JOB_DETAILS_FOR_TIMER_FAILURE =
  "GET_SINGLE_JOB_DETAILS_FOR_TIMER_FAILURE";

//Billable Job Items List
export const GET_BILLABLE_JOB_ITEMS_LIST = "GET_BILLABLE_JOB_ITEMS_LIST";
export const GET_BILLABLE_JOB_ITEMS_LIST_SUCCESS =
  "GET_BILLABLE_JOB_ITEMS_LIST_SUCCESS";
export const GET_BILLABLE_JOB_ITEMS_LIST_FAILURE =
  "GET_BILLABLE_JOB_ITEMS_LIST_FAILURE";

// Billable Job Item Details
export const GET_BILLABLE_JOB_ITEM_DETAILS = "GET_BILLABLE_JOB_ITEM_DETAILS";
export const GET_BILLABLE_JOB_ITEM_DETAILS_SUCCESS =
  "GET_BILLABLE_JOB_ITEM_DETAILS_SUCCESS";
export const GET_BILLABLE_JOB_ITEM_DETAILS_FAILURE =
  "GET_BILLABLE_JOB_ITEM_DETAILS_FAILURE";

// Billable Job Item Create
export const CREATE_BILLABLE_JOB_ITEM = "CREATE_BILLABLE_JOB_ITEM";
export const CREATE_BILLABLE_JOB_ITEM_SUCCESS =
  "CREATE_BILLABLE_JOB_ITEM_SUCCESS";
export const CREATE_BILLABLE_JOB_ITEM_FAILURE =
  "CREATE_BILLABLE_JOB_ITEM_FAILURE";

// Billable Job Item Update
export const UPDATE_BILLABLE_JOB_ITEM = "UPDATE_BILLABLE_JOB_ITEM";
export const UPDATE_BILLABLE_JOB_ITEM_SUCCESS =
  "UPDATE_BILLABLE_JOB_ITEM_SUCCESS";
export const UPDATE_BILLABLE_JOB_ITEM_FAILURE =
  "UPDATE_BILLABLE_JOB_ITEM_FAILURE";

// Billable Job Item Delete
export const DELETE_BILLABLE_JOB_ITEM = "DELETE_BILLABLE_JOB_ITEM";
export const DELETE_BILLABLE_JOB_ITEM_SUCCESS =
  "DELETE_BILLABLE_JOB_ITEM_SUCCESS";
export const DELETE_BILLABLE_JOB_ITEM_FAILURE =
  "DELETE_BILLABLE_JOB_ITEM_FAILURE";
